import qs from 'qs';
import React from 'react';
import { compose, mapProps } from 'recompose';

import { REACT_APP_GOOGLE_MAPS_API_KEY } from '../../constants/env';

const withGoogleMapsProps = compose(
  mapProps(({ locale, ...rest }) => ({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?${qs.stringify({
      key: REACT_APP_GOOGLE_MAPS_API_KEY,
      v: '3.exp',
      libraries: 'geometry,places',
      language: 'en',
    })}`,
    loadingElement: <div />,
    containerElement: (
      <div style={{ height: 'inherit', position: 'relative' }} />
    ),
    mapElement: <div style={{ height: 'inherit', width: '100%' }} />,
    ...rest,
  })),
);

export default withGoogleMapsProps;



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/withGoogleMapsProps.jsx